/**
 * GeneralInfo - Footer general information section
 *
 * Data from centralized config (lib/footerConfig.ts)
 */

import { FooterLinkSection } from './FooterLinkSection'
import { generalInfoSection } from '../../lib'

export function GeneralInfo() {
  return <FooterLinkSection data={generalInfoSection} />
}
